import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { IM_MessageType } from '../../interfaces/message';
import { MessageRow } from './message.row.component';
import { PrescriptionRow } from './prescription.row.component';
import { CallStatusUpdateMessageComponent } from './call-status-update.component';
import { UserStatusUpdateMessageComponent } from './user-status-update.component';
export var IM_MessageComponent = function (_React$Component) {
  _inherits(IM_MessageComponent, _React$Component);

  var _super = _createSuper(IM_MessageComponent);

  function IM_MessageComponent(state, props) {
    _classCallCheck(this, IM_MessageComponent);

    return _super.call(this, state, props);
  }

  _createClass(IM_MessageComponent, [{
    key: "setFocus",
    value: function setFocus() {
      var container = document.getElementById('messageArea');

      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }
  }, {
    key: "orderByDate",
    value: function orderByDate(messageItem1, messageItem2) {
      return messageItem1.postedOn.getTime() - messageItem2.postedOn.getTime();
    }
  }, {
    key: "getMessageComponent",
    value: function getMessageComponent(messageItem) {
      switch (messageItem.messageType) {
        case IM_MessageType.MessageFromPeer:
          var userMessage = messageItem;
          return React.createElement(MessageRow, {
            message: userMessage.message,
            messageFrom: userMessage.messageFrom,
            onRender: this.setFocus.bind(this)
          });

        case IM_MessageType.PrescriptionMessage:
          var prescriptionMessage = messageItem;
          return React.createElement(PrescriptionRow, {
            displayText: prescriptionMessage.message,
            hyperlink: prescriptionMessage.prescriptionLink,
            messageFrom: prescriptionMessage.messageFrom,
            onRender: this.setFocus.bind(this)
          });

        case IM_MessageType.CallStatusUpdateSystemMessage:
          var callStatusUpdateMessage = messageItem;
          return React.createElement(CallStatusUpdateMessageComponent, {
            callStatusUpdateMessage: callStatusUpdateMessage.message,
            onRender: this.setFocus.bind(this)
          });

        case IM_MessageType.UserStatusUpdateSystemMessage:
          var userStatusUpdateMessage = messageItem;
          return React.createElement(UserStatusUpdateMessageComponent, {
            icon: userStatusUpdateMessage.icon,
            userStatusUpdateMessage: userStatusUpdateMessage.message,
            onRender: this.setFocus.bind(this)
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$im_messag,
          _this = this;

      return React.createElement("div", null, (_this$props$im_messag = this.props.im_messages) === null || _this$props$im_messag === void 0 ? void 0 : _this$props$im_messag.sort(this.orderByDate).map(function (messageItem) {
        return _this.getMessageComponent(messageItem);
      }));
    }
  }]);

  return IM_MessageComponent;
}(React.Component);